import { useParams, useNavigate } from 'react-router-dom';
import { Button, Card, Spin, message, theme } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/PageHeader';
import { TipoServicioForm } from './components/TipoServicioForm';
import { useTipoServicio, useUpdateTipoServicio } from './api/useTiposServicio';
import { useHasPermission } from '../../auth/useHasPermission';
import { EmptyState } from '../../components/EmptyState';
import { Permission } from '@aid/shared';

export function TipoServicioEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const tipoServicioId = Number(id);
  const { data: tipoServicio, isLoading, error } = useTipoServicio(tipoServicioId);
  const updateTipoServicio = useUpdateTipoServicio();
  const hasPermission = useHasPermission(Permission.TIPOS_SERVICIO_UPDATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tienes permiso para editar tipos de servicio.</div>;
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !tipoServicio) {
    return (
      <EmptyState
        title="Tipo de servicio no encontrado"
        description="El tipo de servicio que intentas editar no existe o fue eliminado."
      />
    );
  }

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await updateTipoServicio.mutateAsync({ id: tipoServicio.id, dto: values });
      message.success('Tipo de servicio actualizado correctamente');
      navigate(`/tipos-servicio/${tipoServicio.id}`);
    } catch {
      message.error('Error al actualizar el tipo de servicio');
    }
  };

  return (
    <div>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(`/tipos-servicio/${tipoServicio.id}`)}
        style={{ paddingLeft: 0, height: 'auto', marginBottom: 8 }}
      >
        Volver al tipo de servicio
      </Button>
      <PageHeader
        title="Editar tipo de servicio"
        subtitle={tipoServicio.nombre ?? `#${tipoServicio.id}`}
      />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <TipoServicioForm
          mode="edit"
          initialValues={tipoServicio}
          onSubmit={handleSubmit}
          loading={updateTipoServicio.isPending}
        />
      </Card>
    </div>
  );
}
